// This file was automatically generated from render.reportFeedItem.referralDetail.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.reportFeedItem.referralDetail');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.referralDetail.contentReferralOrderReason = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection ebs-form-group"><label class="el8label el8FieldMedium ebs-control-label ebs-col-sm-2">Reason:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardLineHeight el8StandardFontSize el8Preserve ebs-col-sm-10">', soy.$$escapeHtml(opt_data.clinicalReason), '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reportFeedItem.referralDetail.contentReferralOrderDetail = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection ebs-form-group"><label class="el8label el8FieldMedium ebs-control-label ebs-col-sm-2">Auth For:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize el8Preserve ebs-col-sm-10">', soy.$$escapeHtml(opt_data.authorizationFor), '</div></div>', (opt_data.authNumber) ? '<div class="el8FieldSection ebs-form-group"><label class="el8label el8FieldMedium ebs-control-label ebs-col-sm-2">Auth #:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize el8Preserve ebs-col-sm-10">' + soy.$$escapeHtml(opt_data.authNumber) + '</div></div>' : '');
  if (opt_data.icd10CodeObjs && opt_data.icd10CodeObjs.length) {
    var icd10ObjList30096 = opt_data.icd10CodeObjs;
    var icd10ObjListLen30096 = icd10ObjList30096.length;
    for (var icd10ObjIndex30096 = 0; icd10ObjIndex30096 < icd10ObjListLen30096; icd10ObjIndex30096++) {
      var icd10ObjData30096 = icd10ObjList30096[icd10ObjIndex30096];
      output.append('<div class="el8FieldSection ebs-form-group">', (icd10ObjIndex30096 == 0) ? '<label class="el8label el8FieldMedium ebs-control-label ebs-col-sm-2">ICD-10:</label>' : '<label class="el8label el8FieldMedium ebs-control-label ebs-col-sm-2"></label>', '<div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize ebs-col-sm-10">', soy.$$escapeHtml(icd10ObjData30096.code), (icd10ObjData30096.description) ? ' - ' + soy.$$escapeHtml(icd10ObjData30096.description) : '', '</div></div>');
    }
  }
  if (opt_data.icd9CodeObjs && opt_data.icd9CodeObjs.length) {
    var icd9ObjList30113 = opt_data.icd9CodeObjs;
    var icd9ObjListLen30113 = icd9ObjList30113.length;
    for (var icd9ObjIndex30113 = 0; icd9ObjIndex30113 < icd9ObjListLen30113; icd9ObjIndex30113++) {
      var icd9ObjData30113 = icd9ObjList30113[icd9ObjIndex30113];
      output.append('<div class="el8FieldSection ebs-form-group">', (icd9ObjIndex30113 == 0) ? '<label class="el8label el8FieldMedium ebs-control-label ebs-col-sm-2">ICD-9:</label>' : '<label class="el8label el8FieldMedium ebs-control-label ebs-col-sm-2"></label>', '<div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize ebs-col-sm-10">', soy.$$escapeHtml(icd9ObjData30113.code), (icd9ObjData30113.description) ? ' - ' + soy.$$escapeHtml(icd9ObjData30113.description) : '', '</div></div>');
    }
  }
  if (!opt_sb) return output.toString();
};
